import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useI18n } from 'components/I18nProvider';
import { Card, Empty, Spin } from 'antd';
import Page from 'components/Page';
import { fetchTranscription } from 'api/segment';
import { fetchConfig } from 'api/config';
import { buildUrlPath } from 'lib/resolveUrl';
import { getLanguageEmoji, getLocalizedLanguageName } from 'lib/language-display';
import styles from './style.module.scss';
const TranscriptionPage = () => {
    const { eventId, segmentId, lang } = useParams();
    const { intl } = useI18n();
    const [transcription, setTranscription] = useState('loading');
    const [languageEmojiFlags, setLanguageEmojiFlags] = useState({});
    useEffect(() => {
        void fetchConfig()
            .then((config) => setLanguageEmojiFlags(config.languageEmojiFlags ?? {}))
            .catch(() => setLanguageEmojiFlags({}));
    }, []);
    useEffect(() => {
        const fetchTranscriptionState = async () => {
            if (eventId === undefined || segmentId === undefined || lang === undefined) {
                return;
            }
            const transcription = await fetchTranscription(eventId, segmentId, lang);
            if (transcription === null) {
                setTranscription('not-found');
                return;
            }
            else {
                setTranscription(transcription);
            }
        };
        fetchTranscriptionState();
    }, [eventId, segmentId, lang]);
    const languageLabel = lang !== undefined
        ? getLocalizedLanguageName(intl, lang)
        : '';
    const languageEmoji = lang !== undefined
        ? getLanguageEmoji(languageEmojiFlags, lang)
        : '';
    return (_jsx(Page, { children: _jsxs("div", { className: styles.page, children: [eventId !== undefined && (_jsx(Link, { className: styles.backLink, to: buildUrlPath(`/admin/events/${eventId}/segments`), children: intl.formatMessage({ id: 'segments' }) })), _jsxs(Card, { className: styles.card, title: (_jsxs("span", { className: styles.title, children: [languageEmoji !== '' && _jsx("span", { className: styles.flag, children: languageEmoji }), intl.formatMessage({ id: 'transcription' }), languageLabel !== '' && ` — ${languageLabel}`] })), children: [transcription === 'loading' && (_jsx("div", { className: styles.loading, children: _jsx(Spin, {}) })), transcription === 'not-found' && (_jsx(Empty, { description: intl.formatMessage({ id: 'transcriptionNotFound' }) })), transcription !== 'loading' && transcription !== 'not-found' && (_jsx("pre", { className: styles.body, children: transcription }))] })] }) }));
};
export default TranscriptionPage;
